<template>
  <validation-observer ref="observer" v-slot="{ handleSubmit }">
    <b-modal
      id="modal"
      size="md"
      button-size="sm"
      centered
      header-bg-variant="secondary"
      header-text-variant="light"
      header-class=""
      footer-class=""
      modal-class="p-2"
      no-close-on-backdrop
      no-close-on-esc
      @show="onModalShow"
    >
      <template v-slot:modal-header="">
        <h5>Adicionar normativo</h5>
      </template>

      <b-form>
        <b-row>
          <b-col>
            <default-form-validation-provider
              rules="required"
              label="Tipo de Ato Normativo"
              v-slot="defaultState"
            >
              <b-form-select
                :state="defaultState.state"
                v-model="form.tipoAtoNormativo"
                :options="tiposAtoNormativo"
              />
            </default-form-validation-provider>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <default-form-validation-provider
              rules="required|min_value:1"
              label="Número"
              v-slot="defaultState"
            >
              <b-form-input
                :state="defaultState.state"
                v-model="form.numeroAtoNormativo"
                type="number"
                min="1"
              />
            </default-form-validation-provider>
          </b-col>
          <b-col>
            <default-form-validation-provider
              rules="required|min_value:1900"
              label="Ano"
              v-slot="defaultState"
            >
              <b-form-input
                :state="defaultState.state"
                v-model="form.anoAtoNormativo"
                type="number"
                min="1900"
              />
            </default-form-validation-provider>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <default-form-validation-provider
              rules="required"
              label="Veículo de Publicação"
              v-slot="defaultState"
            >
              <b-form-select
                :state="defaultState.state"
                v-model="form.veiculoPublicacao"
                :options="tiposVeiculoPublicacao"
              />
            </default-form-validation-provider>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <default-form-validation-provider
              rules=""
              label="Data de Início de Vigência"
              v-slot="defaultState"
            >
              <b-form-input
                :state="defaultState.state"
                v-model="form.dataInicioVigencia"
                type="date"
              />
            </default-form-validation-provider>
          </b-col>
        </b-row>
      </b-form>

      <template v-slot:modal-footer="">
        <b-button @click="handleSubmit(confirmarSalvar)">Salvar</b-button>
        <b-button variant="outline-secondary" @click="$bvModal.hide('modal')">
          Cancelar
        </b-button>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { ValidationObserver } from "vee-validate";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { UtilsTS } from "@/utilsts";
import { NormativoCargo } from "@/types/atos-pessoal/cargos/normativo-cargo";
import { SelectValue } from "@/types/select-value";

@Component({
  components: {
    ValidationObserver,
    DefaultFormValidationProvider,
  },
})
export default class ModalAdicionarNormativo extends mixins(UtilsTS, Vue) {
  @Prop({ required: true }) tiposAtoNormativo!: SelectValue[];
  @Prop({ required: true }) tiposVeiculoPublicacao!: SelectValue[];
  @Prop({ default: null }) normativoInicial!: NormativoCargo | null;

  form = new NormativoCargo();

  onModalShow(): void {
    this.form = new NormativoCargo({ ...(this.normativoInicial ?? {}) });
  }

  confirmarSalvar(): void {
    const novoNormativo = new NormativoCargo({
      ...this.form,
      numeroAtoNormativo: parseInt(this.form.numeroAtoNormativo as string),
      anoAtoNormativo: parseInt(this.form.anoAtoNormativo as string),
      // "T00:00:00" força parse em horário local; sem ele, JS trata como UTC e desloca -3h no fuso do Brasil
      dataInicioVigencia: this.form.dataInicioVigencia
        ? new Date((this.form.dataInicioVigencia as string) + "T00:00:00")
        : null,
    });
    this.$emit("salvar", novoNormativo);
  }
}
</script>
